import { render } from "./Index.vue?vue&type=template&id=e72bedaa&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-e72bedaa"

export default script